import { hasEngRoleSelector, hasMinGlobalRoleHospitalitySelector } from 'selectors/rolesSelectors';
import { useSelector } from 'react-redux';
import AppSettings from 'settings/AppSettings';

/**
 * Whether the current user can access the new clowncar JCE tools (NewRouterRoot).
 *
 * Engineers can access them in every environment. Other Tock employees
 * (hospitality/finance, via hasMinGlobalRoleHospitalitySelector) can access them
 * only in non-prod environments (staging + demo).
 */
export function useCanAccessNewTool(): boolean {
  const isEng = useSelector(hasEngRoleSelector);
  const isTockEmployee = useSelector(hasMinGlobalRoleHospitalitySelector);
  const isNonProd = AppSettings.APP_ENVIRONMENT !== 'prod';
  return isEng || (isNonProd && isTockEmployee);
}
